<template>
    <div v-if="cartItemsCount > 0" class="flex flex-col justify-between flex-1">
        <div class="">
            <div class="flex mb-8" v-for="(item, index) in cartItems" :key="item.id">
                <div class="flex items-center mr-2">
                    <span class="cursor-pointer" @click="removeItem(item.rowId)"><i class="fas fa-times"></i></span>
                </div>

                <a :href="item.url" class="cart-item__thumb">
                    <img :src="item.image" class="cart-item__thumb-img" alt="productimg">
                </a>

                <div class="flex w-3/4 flex-col justify-between ml-8">
                    <div class="text-right">
                        <a :href="item.url" class="text-black">{{ item.name }}</a>
                    </div>
                    <div class="text-right">
                        &#8364;{{ formatPrice(item.price) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-4 border-t flex flex-col">
            <div v-if="hasVat" class="mb-2 flex justify-between">
                <span class="text-left ">Subtotal</span>
                <span class="text-right ">&#8364;{{ formatPrice(subtotal) }}</span>
            </div>
            <div v-if="hasVat" class="mb-2 flex justify-between">
                <span class="text-left ">VAT ({{ vatRate }}%)</span>
                <span class="text-right">&#8364;{{ formatPrice(vatTotal) }}</span>
            </div>
            <div class="flex justify-between">
                <span class="text-left font-bold">Total</span>
                <span class="text-right font-bold">&#8364;{{ formatPrice(total) }}</span>
            </div>
        </div>
    </div>
    <div v-else class="flex flex-col justify-center items-center">
        <img :src="'/icons/icon_empty.svg'" class="mb-4">
        <p class="text-bold">Empty cart</p>
        <p class="mb-4">Looks like you haven’t made your choice yet</p>
    </div>


</template>

<script>

//import cart from './cart.js';
import { cart, mutations } from "./cart";


export default {
    //name: "cart",
    props: {
        items: {
            type: Array,
            default: []
        },
        totals: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            cart: cart,
        }
    },
    created() {
        mutations.update(this.items, this.totals)
    },
    computed: {
        cartItems() {
            return cart.items;
        },
        cartItemsCount() {
            return cart.items.length;
        },
        total() {
            return cart.totals.total;
        },
        subtotal() {
            return cart.totals.subtotal;
        },
        hasVat() {
            return (typeof cart.totals.vat_total !== 'undefined');
        },
        vatTotal() {
            return cart.totals.vat_total;
        },
        vatRate() {
            return cart.totals.vat_rate;
        },
    },
    methods: {
        removeItem(id) {
            mutations.removeItem(id)
        },
        formatPrice(price) {
            return price.toFixed(2)
        }
    },
}
</script>
